// extracted by mini-css-extract-plugin
module.exports = {"container":"LeagueSelector_container_1YIGE","leagueImage":"LeagueSelector_leagueImage_1XQbg","leagueText":"LeagueSelector_leagueText_2R-PA"};